import React from 'react';
import {MapPin} from 'lucide-react';
import {placePath,usePlaceResource,PlaceDetail} from '../services/placeCommunity';
import CameraImage from './CameraImage';
export default function PlacePrimaryPreview({id,name}:{id:string;name:string}){
 const data=usePlaceResource<PlaceDetail>(placePath(id)),photo=data.data?.primaryPhoto;
 return photo?<CameraImage photo={photo} alt={name} className="w-full h-36 object-cover"/>:
  <div className="h-28 bg-[#e6e9e1] flex items-center justify-center text-[#74806e]" aria-label="No primary photo"><MapPin size={28} strokeWidth={1.4}/></div>;
}
